export const filterOptions = {
  options: ["Views", "Reads"],
  initial: "Views",
};
